import {EditorMode} from "./editor-mode";
import {Layer} from "../../document/model/layer";
import {Feature, Geometry} from "geojson";
import FormRenderPageModalContainer from "../../../pages/documents/FormRenderPageModalContainer.vue";
import {Document} from "../../document/model/document";

export class CustomMode extends EditorMode {
    static identifier: string = "custom";
    static title: string = "Customizabil";
    static icon: string = "/icons/toolbox/gui-magic.svg";
    static allowPriorityContextMenu: boolean = true;
    static requiresLayer: boolean = false;

    getGlobalActions(drawMode): any[] {
        return [];
    }

    getSingleActions(layerGeometry, interactionIdentifier, point: mapboxgl.Point | undefined = undefined): any[] {
        return [];
    }

    getActionOptions(interactionIdentifier): any[]{

    }


    getMultiActions(layerGeometries, drawMode): any[] {
        return [];
    }

    async onLayerGeometriesCreate(features: Feature[]) {
        let customAction;
        switch (this.controller.interaction?.customAction?.actionType) {
            case 'open_form_in_modal':
            case 'open_form_in_page':
                customAction = this.controller.interaction?.customAction as FormInteractionAction;
                this.controller.configuration.dialogProvider().open(FormRenderPageModalContainer, {
                    props: {
                        modal: true,
                        maximizable: true,
                        style: {
                            width: "1024px",
                        },
                    },
                    data: {
                        isOpenInModal: true,
                        formTypeId: customAction?.document?.documentType?.documentTypeId,
                        extraData: features[0],
                    },
                    onClose: (options) => {
                        this.controller.interaction.mode.resetInteraction();
                    }
                }
                );
                break;
            default:
                await super.onLayerGeometriesCreate(features)
        }
    }

}


export type CustomActionType = 'map_interaction' | 'post_message' | 'open_form_in_modal' | 'open_form_in_page';

export class CustomAction {
    actionType: CustomActionType;
}

export class FormInteractionAction extends CustomAction {
    actionType: CustomActionType = 'open_form_in_modal';

    constructor(
        public mapMode: string,
        public drawMode: string,
        public document: Document | undefined = undefined,
    ) {
        super();
    }
}

export class MapInteractionAction extends CustomAction {
    actionType: CustomActionType = 'map_interaction';

    constructor(
        public mapMode: string,
        public drawMode: string,
        public layer: Layer | undefined = undefined
    ) {
        super();
    }
}

export class PostMessageAction extends CustomAction {
    actionType: CustomActionType = 'post_message';

    constructor(
        public message: any,
        public requiresSelection = false,
    ) {
        super();
    }
}
